module.exports = __webpack_public_path__ + "fonts/RocGrotesk-Black.2d1a41a.woff2";